import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Table } from "semantic-ui-react";
import { getUserList } from "../../actions/userActions";
import { Heading2 } from "../../components/value-cssmodules/TextComponent";
import {
  userDeleteSuccess,
  userIsAdminSelector,
  usersListSelector,
} from "../../utils/selectors";
import isEmpty from "../../validation/is-empty";
import UserListRow from "./UserListRow";
import styles from "./UserList.module.scss";
import Spinner from "../../components/Spinner";
import CustomPagination from "../../components/Pagination/CustumPagination";

const UserList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { users, loading } = useSelector((state) => usersListSelector(state));
  const admin = useSelector((state) => userIsAdminSelector(state));
  const deleteSuccess = useSelector((state) => userDeleteSuccess(state));
  const [page, setPage] = useState<number>(1)

  useEffect(() => {
    if (admin) {
      const pageLimit = 10
      dispatch(getUserList(page, pageLimit));
    } else {
      navigate("/admin");
    }
  }, [dispatch, navigate, admin, deleteSuccess, page]);

  if (loading) {
    return <Spinner />;
  }


  return (
    <Grid className={styles.self}>
      <Container>
        <Grid.Row>
          <Heading2>
            <FormattedMessage id="admin.userList.title" />
          </Heading2>
          <Table striped size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.titleId"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.name"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.email"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.isAdmin"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.user.removed"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.actions"} />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!isEmpty(users) &&
                users.users.map((user: any) => {
                  return <UserListRow user={user} key={user._id} />;
                })}
            </Table.Body>
          </Table>
        </Grid.Row>
        <div className={styles.pagination}>
          <CustomPagination
            page={page}
            totalPages={users?.totalPages}
            onPageChange={(p) => setPage(p)}
          />
        </div>
      </Container>
    </Grid>
  );
};

export default UserList;
